var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNumTimer0 = function SvgNumTimer0(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3",
    d: "M4.913 29Q1.6 29 1.6 25.664V10.856q0-3.336 3.312-3.336h10.152q3.336 0 3.336 3.336v14.808Q18.4 29 15.065 29zm8.88-3.888V11.408H6.209v13.704z"
  })));
};
export default SvgNumTimer0;